import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IQuote, IQuoteResponse } from "../models/Quote";

export default function useSingleQuote(quoteId: string) {
    const { get, getFile, post, put, del } = useApiHelper();
    const queryClient = useQueryClient();

    const quote = useQuery({
        queryKey: ["quote", quoteId],
        queryFn: () => get<IQuoteResponse>(`/quote/${quoteId}`),
        staleTime: 1000 * 30, // 30 seconds
        refetchInterval: 1000 * 60 * 10, // 10 minutes
    });

    return {
        quote,
    }
}